import * as O from 'effect/Option';
export enum UserFeedbackTriggerPoint {
  PostLogin = 'post_login',
  DonationUpload = 'donation_upload',
}

export enum UserFeedbackOutcome {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Failed = 'failed',
  Ignored = 'ignored',
}

export interface UserFeedbackTrigger {
  id: number;
  trigger_point: UserFeedbackTriggerPoint;
  form_id: string;
}
export interface ReportUserFeedbackRequest {
  outcome: UserFeedbackOutcome;
}

export interface ReportUserFeedbackResponse {
  statusCode: number;
}

export function matchTriggerToPathFragment(
  trigger: UserFeedbackTrigger,
  pathFragment: string,
): O.Option<UserFeedbackTrigger> {
  const found = userFeedbackTriggersToPaths.find(
    (item) =>
      item.trigger === trigger.trigger_point &&
      pathFragment.includes(item.pathFragment),
  );
  return found ? O.some(trigger) : O.none();
}

const userFeedbackTriggersToPaths: Array<{
  trigger: UserFeedbackTriggerPoint;
  pathFragment: string;
}> = [
  {
    trigger: UserFeedbackTriggerPoint.PostLogin,
    pathFragment: 'post-login',
  },
  {
    trigger: UserFeedbackTriggerPoint.DonationUpload,
    pathFragment: 'forms',
  },
];
